import { render, staticRenderFns } from "./PlayerConfigSourceConfig.vue?vue&type=template&id=2f86c430&scoped=true&"
import script from "./PlayerConfigSourceConfig.vue?vue&type=script&lang=js&"
export * from "./PlayerConfigSourceConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f86c430",
  null
  
)

export default component.exports